export enum CreateOrderMethod {
  CreateOrderFromApi = 'API',
  CreateOrderFromImport = 'Import',
  CreateOrderFromWeb = 'Web',
  CreateOrderFromConsole = 'Console'
}
